module.exports = __webpack_public_path__ + "img/100.1a1a3622.svg";